import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Button from 'uikit/Button/Button';
import Loader from 'components/common/Loader';

// TRN-7388 — one reusable card for the account-type options on the new "Choose Your Account Type"
// screen (see docs/specs/TRN-7388_customer_creation/spec.md §10.2) — avoids repeating near-identical
// icon/title/description/button JSX per option.
const AccountTypeCard = ({ Icon, titleKey, descriptionKey, onRegister, isLoading, isDisabled, children }) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'account-type-card'}>
      <div className={'account-type-card__body'}>
        <div className={'account-type-card__heading'}>
          <div className={'account-type-card__icon'}>
            <Icon />
          </div>
          <p className={'account-type-card__title'}>{i18n.getMessage(titleKey)}</p>
        </div>
        <p className={'account-type-card__description'}>{i18n.getMessage(descriptionKey)}</p>
        {children}
      </div>

      <Button
        type={'primary'}
        size={'large'}
        fullWidth={true}
        onClick={onRegister}
        isDisabled={isDisabled || isLoading}
      >
        {isLoading ? <Loader /> : i18n.getMessage('registration.accountType.button')}
      </Button>
    </div>
  );
};

AccountTypeCard.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string.isRequired,
  onRegister: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  children: PropTypes.node
};

export default AccountTypeCard;
